const getStyles = () => {
  return {
    section: {
      position: 'relative',
      padding: { xs: '60px 20px', md: '120px 20px' },
      minHeight: '100vh',
      overflow: 'hidden',
      background:
        'linear-gradient(180deg, #0a0e27 0%, #1a1f3a 50%, #0a0e27 100%)'
    },

    // Background Elements
    backgroundContainer: {
      position: 'absolute',
      inset: 0,
      overflow: 'hidden',
      pointerEvents: 'none'
    },

    gradientBase: {
      position: 'absolute',
      inset: 0,
      background:
        'radial-gradient(circle at 50% 30%, rgba(12, 90, 219, 0.15) 0%, transparent 60%)'
    },

    meshGradient: {
      position: 'absolute',
      inset: 0,
      background:
        'radial-gradient(at 15% 20%, rgba(12, 90, 219, 0.12) 0px, transparent 50%), radial-gradient(at 85% 80%, rgba(138, 43, 226, 0.1) 0px, transparent 50%), radial-gradient(at 50% 50%, rgba(58, 142, 246, 0.08) 0px, transparent 50%)'
    },

    floatingShape1: {
      position: 'absolute',
      top: '15%',
      right: '10%',
      width: '200px',
      height: '200px',
      border: '2px solid rgba(58, 142, 246, 0.3)',
      borderRadius: '40% 60% 60% 40% / 60% 40% 60% 40%',
      transition: 'transform 0.3s ease-out'
    },

    floatingShape2: {
      position: 'absolute',
      bottom: '20%',
      left: '5%',
      width: '250px',
      height: '250px',
      border: '2px solid rgba(138, 43, 226, 0.25)',
      borderRadius: '60% 40% 30% 70% / 60% 30% 70% 40%',
      transition: 'transform 0.3s ease-out'
    },

    floatingShape3: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: '180px',
      height: '180px',
      border: '2px solid rgba(12, 90, 219, 0.2)',
      borderRadius: '50% 50% 40% 60% / 40% 60% 50% 50%',
      transition: 'transform 0.3s ease-out'
    },

    glowOrb1: {
      position: 'absolute',
      top: '10%',
      left: '20%',
      width: '500px',
      height: '500px',
      borderRadius: '50%',
      background:
        'radial-gradient(circle, rgba(12, 90, 219, 0.4) 0%, transparent 70%)',
      filter: 'blur(80px)',
      animation: 'pulse 8s ease-in-out infinite',
      transition: 'transform 0.5s ease-out'
    },

    glowOrb2: {
      position: 'absolute',
      bottom: '15%',
      right: '15%',
      width: '450px',
      height: '450px',
      borderRadius: '50%',
      background:
        'radial-gradient(circle, rgba(138, 43, 226, 0.35) 0%, transparent 70%)',
      filter: 'blur(90px)',
      animation: 'pulse 10s ease-in-out infinite',
      transition: 'transform 0.5s ease-out'
    },

    glowOrb3: {
      position: 'absolute',
      top: '40%',
      right: '25%',
      width: '400px',
      height: '400px',
      borderRadius: '50%',
      background:
        'radial-gradient(circle, rgba(58, 142, 246, 0.3) 0%, transparent 70%)',
      filter: 'blur(70px)',
      animation: 'pulse 12s ease-in-out infinite',
      transition: 'transform 0.5s ease-out'
    },

    particle: {
      position: 'absolute',
      width: '3px',
      height: '3px',
      background: 'rgba(58, 142, 246, 0.9)',
      borderRadius: '50%',
      animation: 'particleFloat linear infinite',
      boxShadow: '0 0 8px rgba(58, 142, 246, 0.6)'
    },

    lightBeam1: {
      position: 'absolute',
      top: '25%',
      right: '15%',
      width: '300px',
      height: '300px',
      background:
        'radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%)',
      borderRadius: '50%',
      filter: 'blur(60px)',
      transition: 'transform 0.6s ease-out'
    },

    lightBeam2: {
      position: 'absolute',
      bottom: '35%',
      left: '10%',
      width: '350px',
      height: '350px',
      background:
        'radial-gradient(circle, rgba(58, 142, 246, 0.12) 0%, transparent 70%)',
      borderRadius: '50%',
      filter: 'blur(70px)',
      transition: 'transform 0.6s ease-out'
    },

    // Content Styles
    container: {
      position: 'relative',
      maxWidth: '1400px',
      margin: '0 auto',
      zIndex: 10
    },

    header: {
      textAlign: 'center',
      marginBottom: { xs: '50px', md: '100px' },
      animation: 'fadeInUp 1s ease-out'
    },

    headerBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '10px',
      padding: '10px 24px',
      marginBottom: '32px',
      borderRadius: '50px',
      background: 'rgba(255, 255, 255, 0.05)',
      backdropFilter: 'blur(20px)',
      border: '1px solid rgba(58, 142, 246, 0.3)',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)'
    },

    badgeIcon: {
      fontSize: '18px'
    },

    badgeText: {
      fontSize: '13px',
      fontWeight: 700,
      color: '#ffffff',
      letterSpacing: '1px',
      textTransform: 'uppercase'
    },

    title: {
      fontSize: { xs: '32px', sm: '42px', md: '52px', lg: '64px' },
      fontWeight: 900,
      marginBottom: '28px',
      color: '#ffffff',
      lineHeight: 1.1
    },

    titleGradient: {
      background:
        'linear-gradient(135deg, #0c5adb 0%, #3a8ef6 50%, #8a2be2 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      backgroundSize: '200% 200%',
      animation: 'gradientShift 4s ease infinite'
    },

    subtitle: {
      fontSize: { xs: '15px', sm: '17px', md: '20px' },
      color: 'rgba(255, 255, 255, 0.65)',
      maxWidth: '700px',
      margin: '0 auto',
      lineHeight: 1.8,
      fontWeight: 300
    },

    // Grid Styles
    grid: {
      display: 'grid',
      gridTemplateColumns: {
        xs: '1fr',
        sm: 'repeat(auto-fit, minmax(400px, 1fr))',
        lg: 'repeat(auto-fit, minmax(500px, 1fr))'
      },
      gap: { xs: '24px', md: '40px' },
      marginBottom: { xs: '50px', md: '100px' }
    },

    gridItem: {
      animation: 'fadeInUp 0.8s ease-out backwards'
    },

    projectCard: {
      position: 'relative',
      height: '300px',
      borderRadius: '28px',
      overflow: 'hidden',
      cursor: 'pointer',
      transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
      '&:hover': {
        transform: 'translateY(-10px)',
        boxShadow: '0 30px 60px rgba(0, 0, 0, 0.4)'
      }
    },

    cardGlow: {
      position: 'absolute',
      inset: '-100%',
      filter: 'blur(60px)',
      transition: 'all 0.5s ease',
      pointerEvents: 'none'
    },

    imageWrapper: {
      position: 'absolute',
      inset: 0,
      overflow: 'hidden'
    },

    projectImage: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      transition: 'transform 0.7s cubic-bezier(0.4, 0, 0.2, 1)'
    },

    imageOverlay: {
      position: 'absolute',
      inset: 0,
      background:
        'linear-gradient(to top, rgba(10, 14, 39, 0.98) 0%, rgba(10, 14, 39, 0.8) 40%, transparent 100%)',
      transition: 'opacity 0.5s ease'
    },

    contentOverlay: {
      position: 'absolute',
      inset: 0,
      padding: { xs: '30px', md: '40px' },
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      zIndex: 5,
      transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
    },

    projectInfo: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      padding: '12px 24px'
    },

    projectName: {
      fontSize: { xs: '24px', sm: '28px', md: '32px' },
      fontWeight: 900,
      color: '#ffffff',
      marginBottom: '8px',
      letterSpacing: '-0.5px',
      textShadow: '0 2px 20px rgba(0, 0, 0, 0.5)'
    },

    projectDescription: {
      fontSize: { xs: '14px', md: '16px' },
      color: 'rgba(255, 255, 255, 0.85)',
      lineHeight: 1.6,
      marginBottom: '8px'
    },

    visitButton: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '12px',
      padding: '8px 16px',
      borderRadius: '16px',
      textTransform: 'none',
      border: 'none',
      color: '#ffffff',
      fontSize: '14px',
      fontWeight: 700,
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
      alignSelf: 'flex-start',
      '&:hover': {
        transform: 'translateX(8px)',
        boxShadow: '0 12px 32px rgba(0, 0, 0, 0.4)'
      }
    },

    buttonText: {
      letterSpacing: '0.5px'
    },

    buttonIcon: {
      fontSize: '20px',
      transition: 'transform 0.3s ease'
    },

    floatingBadge: {
      position: 'absolute',
      top: '24px',
      left: '24px',
      padding: '12px 20px',
      borderRadius: '16px',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
      backdropFilter: 'blur(10px)',
      zIndex: 6,
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
    },

    badgeNumber: {
      fontSize: '18px',
      fontWeight: 900,
      color: '#ffffff',
      letterSpacing: '1px'
    },

    cornerDecoration: {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '40px',
      height: '40px',
      borderTop: '3px solid',
      borderLeft: '3px solid',
      borderTopLeftRadius: '28px',
      transition: 'all 0.4s ease',
      zIndex: 7
    },

    cornerDecorationBottom: {
      position: 'absolute',
      bottom: '0',
      right: '0',
      width: '40px',
      height: '40px',
      borderBottom: '3px solid',
      borderRight: '3px solid',
      borderBottomRightRadius: '28px',
      transition: 'all 0.4s ease',
      zIndex: 7
    },

    animatedBorder: {
      position: 'absolute',
      inset: 0,
      borderRadius: '28px',
      border: '2px solid',
      transition: 'all 0.4s ease',
      pointerEvents: 'none',
      zIndex: 8
    },

    sparkle: {
      position: 'absolute',
      width: '8px',
      height: '8px',
      background: '#ffffff',
      borderRadius: '50%',
      boxShadow: '0 0 20px rgba(255, 255, 255, 0.8)',
      animation: 'sparkleAnimation 2s ease-in-out infinite',
      zIndex: 9
    },

    sparkle1: {
      top: '30%',
      right: '20%',
      animationDelay: '0s'
    },

    sparkle2: {
      top: '60%',
      right: '15%',
      animationDelay: '0.7s'
    },

    sparkle3: {
      top: '45%',
      right: '35%',
      animationDelay: '1.4s'
    },

    // Bottom CTA
    bottomCTA: {
      display: 'flex',
      justifyContent: 'center',
      padding: { xs: '40px 20px', md: '80px 20px' }
    },

    ctaContent: {
      textAlign: 'center',
      padding: { xs: '40px 30px', sm: '50px 40px', md: '60px 80px' },
      borderRadius: '32px',
      background: 'rgba(255, 255, 255, 0.03)',
      backdropFilter: 'blur(20px)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
      maxWidth: '800px',
      width: '100%'
    },

    ctaTitle: {
      fontSize: { xs: '28px', sm: '32px', md: '42px' },
      fontWeight: 900,
      color: '#ffffff',
      marginBottom: '16px',
      background:
        'linear-gradient(135deg, #ffffff 0%, rgba(255, 255, 255, 0.7) 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text'
    },

    ctaSubtitle: {
      fontSize: { xs: '14px', md: '18px' },
      color: 'rgba(255, 255, 255, 0.6)',
      marginBottom: '32px'
    },

    ctaButton: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '12px',
      padding: { xs: '14px 32px', md: '18px 40px' },
      background: 'linear-gradient(135deg, #0c5adb 0%, #3a8ef6 100%)',
      border: 'none',
      borderRadius: '20px',
      color: '#ffffff',
      fontSize: { xs: '14px', md: '16px' },
      fontWeight: 700,
      cursor: 'pointer',
      transition: 'all 0.4s ease',
      boxShadow: '0 10px 40px rgba(12, 90, 219, 0.4)',
      '&:hover': {
        transform: 'translateY(-3px)',
        boxShadow: '0 15px 50px rgba(12, 90, 219, 0.6)'
      }
    },

    ctaButtonText: {
      letterSpacing: '0.5px'
    },

    ctaButtonIcon: {
      fontSize: '20px'
    },

    // Animation Keyframes
    '@keyframes fadeInUp': {
      from: {
        opacity: 0,
        transform: 'translateY(60px)'
      },
      to: {
        opacity: 1,
        transform: 'translateY(0)'
      }
    },

    '@keyframes float': {
      '0%, 100%': {
        transform: 'translateY(0px)'
      },
      '50%': {
        transform: 'translateY(-25px)'
      }
    },

    '@keyframes pulse': {
      '0%, 100%': {
        opacity: 0.3
      },
      '50%': {
        opacity: 0.6
      }
    },

    '@keyframes particleFloat': {
      '0%': {
        transform: 'translate(0, 0) scale(1)',
        opacity: 0
      },
      '10%': {
        opacity: 0.8
      },
      '90%': {
        opacity: 0.8
      },
      '100%': {
        transform: 'translate(150px, -150vh) scale(0)',
        opacity: 0
      }
    },

    '@keyframes gradientShift': {
      '0%, 100%': {
        backgroundPosition: '0% 50%'
      },
      '50%': {
        backgroundPosition: '100% 50%'
      }
    },

    '@keyframes sparkleAnimation': {
      '0%, 100%': {
        transform: 'scale(0) rotate(0deg)',
        opacity: 0
      },
      '50%': {
        transform: 'scale(1) rotate(180deg)',
        opacity: 1
      }
    },

    '@keyframes shimmer': {
      '0%': {
        backgroundPosition: '-1000px 0'
      },
      '100%': {
        backgroundPosition: '1000px 0'
      }
    }
  };
};

export default getStyles;
